export const PERMS = {
    READ: 'border_crossings.read',
    UPDATE: 'border_crossings.update',
    DELETE: 'border_crossings.delete',
    CREATE: 'border_crossings.create',
    EXPORT: 'border_crossings.export',
}
